import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/joy";
import { useNavigate, useSearchParams } from "react-router-dom";
import { broadcastEvent, clearUser } from "../services/Authentication";
import mixpanel from "mixpanel-browser";
import { axiosInstance } from "../services/Axios";
import { handleErrorSentry } from "../utils/constants/Error";


function ConsumeAuthPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const consumeAuthToken = async (consume_token) => {
        try {
            localStorage.setItem('token', consume_token);
            const response = await axiosInstance.get('/api/v1/user/exchange');
            const credentials = response.data
            localStorage.setItem('email', credentials.email);
            localStorage.setItem('token', credentials.token);
            localStorage.setItem('user_id', credentials.user_id);
            mixpanel.identify(credentials.user_id);
            mixpanel.people.set({
                "$email": credentials.email,
                "user_id": credentials.user_id,
            });
            if (credentials.force_update_password) {
                navigate('/reset-password');
            } else {
                broadcastEvent('localStorageChange', { key: 'token', value: response.data.token });
                navigate('/new-visit');
            }
        } catch(error) {
            clearUser();
            navigate('/login?error=failed_auth_exchange');
            handleErrorSentry(error, "tryCatch");
        }
    }

    useEffect(() => {
        const exchangeToken = async () => {
            const token = params.get("token");
            await consumeAuthToken(token);
        }

        exchangeToken();
    }, [])


    return <Box sx={{ width: "100%", height: "100%"}}>
        <CircularProgress />
    </Box>
}

export default ConsumeAuthPage;